import React from 'react';
import { useTranslation } from 'react-i18next';
import { IVehicle } from './types';

export function PriceEstimate ({ vehicle }: { vehicle: IVehicle }) {
    const {
        estimate,
        mileage,
        sellDuration,
    } = vehicle;

    const { t } = useTranslation('vehicles');

    return (
        <div className="vehicle-price-estimate-display-new-sections">
            <div className="vehicle-price-estimate-display-new-section">
                <div className="vehicle-price-estimate-display-new-text">
                    {t('vehicles:pricePrediction.priceEstimate')}
                </div>
                <div className="vehicle-price-estimate-display-new-number">
                    {estimate} €
                </div>
            </div>
            <div className="vehicle-price-estimate-display-new-section">
                <div className="vehicle-price-estimate-display-new-text">
                    {t('vehicles:pricePrediction.salesTimeEstimate')}
                </div>
                <div className="vehicle-price-estimate-display-new-number">
                    {sellDuration ? Math.round(sellDuration) : '-'} pv
                </div>
            </div>
            <div className="vehicle-price-estimate-display-new-section">
                <div className="vehicle-price-estimate-display-new-text">
                    {t('vehicleProfile:withMileage')}
                </div>
                <div className="vehicle-price-estimate-display-new-number">
                    {mileage} km
                </div>
            </div>
        </div>
    );
}
